import { useEffect, useState } from 'react';
import { sendServiceRequest } from '@resistdesign/voltra/app/utils';
import { Profile } from '../../common/Types';
import { APP_ENV_CONFIG } from '../config';

const {
  api: { domain: API_DOMAIN },
} = APP_ENV_CONFIG;

type EmployerAccountStatusState = {
  authorization: string;
  isResolved: boolean;
  isInactiveEmployer: boolean;
};

export type EmployerAccountStatus = {
  isResolved: boolean;
  isInactiveEmployer: boolean;
};

export const useEmployerAccountStatus = (authorization: string, isGroupAdmin: boolean): EmployerAccountStatus => {
  const [status, setStatus] = useState<EmployerAccountStatusState>({
    authorization,
    isResolved: !authorization || isGroupAdmin,
    isInactiveEmployer: false,
  });

  useEffect(() => {
    let cancelled = false;

    setStatus({
      authorization,
      isResolved: !authorization || isGroupAdmin,
      isInactiveEmployer: false,
    });

    const resolveStatus = async (): Promise<void> => {
      let isInactiveEmployer = false;

      try {
        const profile = (await sendServiceRequest(
          {
            protocol: 'https',
            domain: API_DOMAIN,
            basePath: '/user/profile',
            authorization,
          },
          '/read'
        )) as Profile | undefined;

        isInactiveEmployer = !!profile?.groupAdminIdCode;
      } catch (error) {
        isInactiveEmployer = false;
      }

      if (!cancelled) {
        setStatus({
          authorization,
          isResolved: true,
          isInactiveEmployer,
        });
      }
    };

    if (authorization && !isGroupAdmin) {
      void resolveStatus();
    }

    return () => {
      cancelled = true;
    };
  }, [authorization, isGroupAdmin]);

  const statusMatchesAuthorization = status.authorization === authorization;

  return {
    isResolved: !authorization || isGroupAdmin || (statusMatchesAuthorization && status.isResolved),
    isInactiveEmployer:
      !!authorization && !isGroupAdmin && statusMatchesAuthorization && status.isInactiveEmployer,
  };
};
